import { useQuery } from '@tanstack/react-query';
import automateAxios from '../../../utils/automateAxios';
import { QueryKeys } from '../../querys/querys.enum';
import { AutomationPrompt } from '../../../models/Interface/Automation.interface';

const fetchPrompts = async (): Promise<AutomationPrompt[]> => {
  const response = await automateAxios.get<AutomationPrompt[]>('/prompts');
  return response.data;
};

const useAutomationPrompts = () => {
  return useQuery<AutomationPrompt[]>({
    queryKey: [QueryKeys.AUTOMATION_PROMPTS],
    queryFn: fetchPrompts,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5,
  });
};

export default useAutomationPrompts;
